export const enplast = {
  enplast_discrepancy_item_productclient_unitprice_mismatch: `Item '{{1}}' price '{{2}}' mismatch with defined price '{{3}}'`,
};
